import i18n from '@/config/i18n'
import NotFound from '../views/404.vue'

export default {
  initial() {
    return [
      {
        path: '/:lang',
        component: {
          render: h => h('router-view'),
        },
        children: [
          {
            name: 'Dashboard',
            meta: {
              active: false,
              auth: true,
              icon: '/static/img/dashboard.svg',
              skipTopNav: true,
              skipHeading: true,
              skipMenu: false,
              T: 'dashboard',
              showSideBar: true,
              showHeader: true,
              footer: true,
              description: 'dashboard_description',
              identifierPath: 'dashboard',
            },
            path: '',
            component: require('../views/QuickMenu').default,
          },
          {
            path: 'login',
            name: 'Login',
            meta: {
              auth: false,
              skipStructure: true,
              skipMenu: true,
              T: 'login_to_your_account',
              navActive: false,
              showSideBar: false,
              showHeader: true,
              footer: true,
              description: 'login_description',
              identifierPath: 'login',
            },
            component: require('../views/auth/Login').default,
          },
          {
            meta: {
              active: false,
              icon: '/static/img/local-depositor.svg',
              T: 'local_depositor',
              needsPrivileges: ['local_depositor'],
              auth: true,
              skipMenu: false,
              showSideBar: true,
              showHeader: true,
              footer: true,
              description: 'ld_description',
            },
            path: 'local-depositor',
            component: {
              render: h => h('router-view'),
            },
            children: [
              {
                path: '',
                name: 'Local Depositor',
                meta: {
                  auth: true,
                  navActive: false,
                  T: 'local_depositor',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  description: 'ld_description',
                  identifierPath: 'local-depositor',
                },
                component: require('../views/local-depositor/Dashboard.vue').default,
              },
            ],
          },
          {
            meta: {
              active: false,
              icon: '/static/img/trading.svg',
              T: 'trading',
              auth: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'trading_description',
            },
            path: 'trading-account',
            component: require('../views/TA/TA.vue').default,
            children: [
              {
                path: '',
                name: 'Account list',
                meta: {
                  navActive: false,
                  T: 'account_list',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'trading-account',
                },
                component: require('../views/TA/ListAccounts').default,
              },
              {
                path: 'vps',
                name: 'VPS',
                meta: {
                  navActive: false,
                  T: 'vps',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'trading-account/vps',
                },
                component: require('../views/TA/VPS').default,
              },
              {
                path: 'download',
                name: 'Platforms',
                meta: {
                  navActive: false,
                  T: 'download',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'trading-account/download',
                },
                component: require('../views/TA/Download').default,
              },
            ],
          },
          {
            meta: {
              active: false,
              icon: '/static/img/transactions.svg',
              T: 'transactions',
              auth: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'transactions_description',
            },
            path: 'finance',
            component: require('../views/finance/Finance.vue').default,
            children: [
              {
                path: '',
                name: 'Deposit',
                meta: {
                  navActive: false,
                  T: 'deposit',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'finance',
                },
                component: require('../views/finance/Deposit.vue').default,
              },
              {
                path: 'withdraw',
                name: 'Withdraw',
                meta: {
                  navActive: false,
                  T: 'withdraw',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'finance/withdraw',
                },
                component: require('../views/finance/Withdraw').default,
              },
              {
                path: 'internal-transfer',
                name: 'Internal Transfer',
                meta: {
                  navActive: false,
                  T: 'internal_transfer',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'finance/internal-transfer',
                },
                component: require('../views/finance/InternalTransfer').default,
              },
              {
                path: 'payment-history',
                name: 'Payment History',
                meta: {
                  navActive: false,
                  T: 'payment_history',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'finance/payment-history',
                },
                component: require('../views/finance/PaymentHistory').default,
              },
              {
                path: 'my-cards',
                name: 'My Cards',
                meta: {
                  navActive: false,
                  T: 'my_cards',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'finance/my-cards',
                },
                component: require('../views/finance/MyCards').default,
              },
              {
                path: 'my-bonuses',
                name: 'My Bonuses',
                meta: {
                  navActive: false,
                  T: 'bonuses',
                  needsPrivileges: ['live'],
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'finance/my-bonuses',
                },
                component: require('../views/my-bonuses').default,
              },
            ],
          },
          {
            meta: {
              active: false,
              icon: '/static/img/cashback_menu_icon.svg',
              T: 'cashback',
              needsPrivileges: ['live'],
              auth: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: false,
              description: 'cashback_description',
              identifierPath: 'cashback',
            },
            path: 'cashback',
            name: 'Cashback',
            component: require('../views/cashback/Cashback.vue').default,
          },
          {
            meta: {
              active: false,
              icon: '/static/img/pamm.svg',
              T: 'pamm',
              needsPrivileges: ['live'],
              auth: true,
              skipMenu: false,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'pamm_description',
            },
            path: 'pamm',
            component: require('../views/pamm/PAMM.vue').default,
            children: [
              {
                path: '',
                name: 'PAMM statistics',
                meta: {
                  navActive: false,
                  T: 'pamm',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'pamm',
                },
                component: require('../views/pamm/pamm-statistics').default,
              },
              {
                path: 'new-master',
                name: 'Create a new master account',
                meta: {
                  navActive: false,
                  T: 'new_master_account',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'pamm/new-master',
                },
                component: require('../views/pamm/new-master').default,
              },
            ],
          },
          {
            meta: {
              active: false,
              icon: '/static/img/copy-trading.svg',
              T: 'copy_trading',
              needsPrivileges: ['live'],
              auth: true,
              skipMenu: false,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'copy_trading_description',
            },
            path: 'copy-trading',
            component: require('../views/copy-trading/CopyTrading.vue').default,
            children: [
              {
                path: '',
                name: 'All Providers',
                meta: {
                  navActive: false,
                  T: 'copy_trading',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'copy-trading',
                },
                component: require('../views/copy-trading/AllProviders').default,
              },
              {
                path: 'highest-return-providers',
                name: 'Highest Return Providers',
                meta: {
                  navActive: false,
                  T: 'highest_return_providers',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'copy-trading/highest-return-providers',
                },
                component: require('../views/copy-trading/HighestReturnProviders').default,
              },
              {
                path: 'top-risk-adjusted-return',
                name: 'Top Risk Adjusted Return',
                meta: {
                  navActive: false,
                  T: 'top_risk_adjusted_return',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'copy-trading/top-risk-adjusted-return',
                },
                component: require('../views/copy-trading/TopRiskAdjustedReturn').default,
              },
              {
                path: 'most-heavily-invested',
                name: 'Most Heavily Invested',
                meta: {
                  navActive: false,
                  T: 'most_heavily_invested',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'copy-trading/most-heavily-invested',
                },
                component: require('../views/copy-trading/MostHeavilyInvested').default,
              },
            ],
          },
          {
            meta: {
              active: false,
              icon: '/static/img/partners.svg',
              T: 'partners',
              needsPrivileges: ['ib'],
              auth: true,
              skipMenu: false,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'partner_description',
            },
            path: 'partner',
            component: require('../views/partner/Partner.vue').default,
            children: [
              {
                path: '',
                name: 'Partner Overview',
                meta: {
                  navActive: false,
                  T: 'partners',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'partner',
                },
                component: require('../views/partner/Overview').default,
              },
              {
                path: 'marketing-material',
                name: 'Partner Marketing Material',
                meta: {
                  navActive: false,
                  T: 'marketing_material',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'partner/marketing-material',
                },
                component: require('../views/partner/MarketingMaterial').default,
              },
            ],
          },
          {
            path: 'competitions',
            meta: {
              active: false,
              icon: '/static/img/competitions.svg',
              T: 'competitions',
              needsPrivileges: ['live'],
              restrictedUS: true,
              auth: true,
              skipMenu: false,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'competitions_description',
            },
            component: require('../views/competitions/Competitions.vue').default,
            children: [
              {
                path: '',
                name: 'In Progress',
                meta: {
                  navActive: false,
                  T: 'in_progress',
                  auth: true,
                  restrictedUS: true,
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  description: 'competitions_description',
                  identifierPath: 'competitions',
                },
                component: require('../views/competitions/InProgress.vue').default,
              },
              {
                path: 'finished',
                name: 'Finished',
                meta: {
                  navActive: false,
                  T: 'finished',
                  auth: true,
                  restrictedUS: true,
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  description: 'competitions_description',
                  identifierPath: 'competitions/finished',
                },
                component: require('../views/competitions/Finished.vue').default,
              },
              {
                path: 'upcoming',
                name: 'Upcoming',
                meta: {
                  navActive: false,
                  T: 'upcoming',
                  auth: true,
                  restrictedUS: true,
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  description: 'competitions_description',
                  identifierPath: 'competitions/upcoming',
                },
                component: require('../views/competitions/Upcoming.vue').default,
              },
              {
                path: 'enter',
                name: 'Enter Competition',
                meta: {
                  T: 'enter_comp',
                  restrictedUS: true,
                  showSideBar: true,
                  auth: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: false,
                  description: 'competitions_description',
                  identifierPath: 'competitions/enter',
                },
                component: require('../views/competitions/EnterCompetition.vue').default,
                props: true,
              },
              {
                path: 'leaderboard',
                name: 'Leaderboard',
                meta: {
                  T: 'leaderboard',
                  auth: true,
                  restrictedUS: true,
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: false,
                  description: 'competitions_description',
                  identifierPath: 'competitions/leaderboard',
                },
                component: require('../views/competitions/Leaderboard/Leaderboard.vue').default,
                props: true,
              },
            ],
          },
          {
            meta: {
              active: false,
              icon: '/static/img/tools-icon.svg',
              T: 'tools',
              needsPrivileges: ['live', 'depositAmount'],
              auth: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'tools_description',
            },
            path: 'tools',
            component: require('../views/tools/Tools.vue').default,
            children: [
              {
                path: '',
                name: 'Economic Calendar',
                meta: {
                  navActive: false,
                  T: 'tools',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'tools',
                },
                component: require('../views/tools/EconomicCalendar.vue').default,
              },
              {
                path: 'technical-views',
                name: 'Technical Views',
                meta: {
                  navActive: false,
                  T: 'technical_views',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'tools/technical-views',
                },
                component: require('../views/tools/TechnicalViews.vue').default,
              },
              {
                path: 'alpha-generation',
                name: 'Alpha Generation Plugin',
                meta: {
                  navActive: false,
                  T: 'alpha_generation',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'tools/alpha-generation',
                },
                component: require('../views/tools/AlphaGeneration.vue').default,
              },
              {
                path: 'education',
                name: 'Education',
                meta: {
                  navActive: false,
                  T: 'education',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'tools/education',
                },
                component: require('../views/tools/Education.vue').default,
              },
              {
                path: 'market-buzz',
                name: 'Market Buzz',
                meta: {
                  navActive: false,
                  T: 'market_buzz',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'tools/market-buzz',
                },
                component: require('../views/tools/MarketBuzz.vue').default,
              },
              {
                path: 'newsletter',
                name: 'Newsletter',
                meta: {
                  navActive: false,
                  T: 'newsletter',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'tools/newsletter',
                },
                component: require('../views/tools/Newsletter.vue').default,
              },
            ],
          },
          {
            meta: {
              active: false,
              icon: '/static/img/my-settings.svg',
              T: 'my_settings',
              auth: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
              usesSubMenuItems: true,
              description: 'profile_description',
            },
            path: 'profile',
            component: require('../views/profile/Profile.vue').default,
            children: [
              {
                path: '',
                name: 'Personal Information',
                meta: {
                  navActive: false,
                  T: 'personal_information',
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'profile',
                },
                component: require('../views/profile/PersonalInformation').default,
              },
              // {
              //   path: 'change-password',
              //   name: 'Change Password',
              //   meta: {
              //     navActive: false,
              //     T: 'change_password',
              //   },
              //   component: require('../views/profile/ChangePassword').default,
              // },
              {
                path: 'upload-documents',
                name: 'Upload Documents',
                meta: {
                  navActive: false,
                  T: 'upload_documents',
                  needsPrivileges: ['live'],
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'profile/upload-documents',
                },
                component: require('../views/profile/UploadDocuments').default,
              },
              {
                path: 'guidance-documents',
                name: 'Guidance Documents',
                meta: {
                  navActive: false,
                  T: 'guidance_documents',
                  needsPrivileges: ['live'],
                  showSideBar: true,
                  showHeader: true,
                  footer: true,
                  usesSubMenuItems: true,
                  identifierPath: 'profile/guidance-documents',
                },
                component: require('../views/profile/guidance-documents/Base').default,
              },
            ],
          },
          {
            meta: {
              active: false,
              T: 'register',
              skipStructure: true,
              skipMenu: true,
              showSideBar: false,
              showHeader: true,
              footer: true,
              description: 'register_description',
            },
            path: 'register',
            component: {
              render: h => h('router-view'),
            },
            children: [
              {
                path: '',
                name: 'Register',
                meta: {
                  auth: false,
                  navActive: false,
                  T: 'register',
                  showSideBar: false,
                  showHeader: true,
                  footer: true,
                  identifierPath: 'register',
                  description: 'register_description',
                  // registerComponent: 'Live',
                },
                component: require('../views/register/Index').default,
              },
              {
                path: 'live',
                name: 'Register Live',
                meta: {
                  auth: false,
                  navActive: false,
                  T: 'register_live_account',
                  registerComponent: 'Live',
                  showSideBar: false,
                  showHeader: false,
                  footer: false,
                  description: 'register_description',
                  identifierPath: 'register/live',
                },
                component: require('../views/register/Base').default,
              },
              {
                path: 'partner',
                name: 'Register Partner',
                meta: {
                  auth: false,
                  navActive: false,
                  T: 'register_partner_account',
                  registerComponent: 'Partner',
                  showSideBar: false,
                  showHeader: false,
                  footer: false,
                  description: 'register_description',
                  identifierPath: 'register/partner',
                },
                component: require('../views/register/Base').default,
              },
              {
                path: 'demo',
                name: 'Register Demo',
                meta: {
                  auth: false,
                  navActive: false,
                  T: 'register_demo_account',
                  registerComponent: 'Demo',
                  showSideBar: false,
                  showHeader: false,
                  footer: false,
                  description: 'register_description',
                  identifierPath: 'register/demo',
                },
                component: require('../views/register/Base').default,
              },
              {
                path: 'upgrade',
                name: 'Upgrade to live',
                meta: {
                  auth: true,
                  navActive: false,
                  T: 'upgrade_to_live_account',
                  registerComponent: 'Upgrade-live',
                  showSideBar: false,
                  showHeader: false,
                  footer: false,
                  description: 'register_description',
                  identifierPath: 'register/upgrade',
                },
                component: require('../views/register/Base').default,
              },
            ],
          },
          {
            path: 'verify-email',
            name: 'Verify Email',
            meta: {
              auth: true,
              navActive: false,
              skipStructure: true,
              skipMenu: true,
              showSideBar: false,
              showHeader: true,
              footer: true,
              description: 'verify_email_description',
              identifierPath: 'verify-email',
              T: 'verify_your_email',
            },
            component: require('../views/auth/VerifyEmail').default,
          },
          {
            path: 'forgot-password',
            name: 'Forgot Password',
            meta: {
              auth: false,
              skipStructure: true,
              skipMenu: true,
              showSideBar: false,
              showHeader: true,
              footer: true,
              description: 'forgot_pass_description',
              identifierPath: 'forgot-password',
            },
            component: require('../views/auth/ForgotPassword').default,
          },
          {
            path: 'transfer-reset-password',
            name: 'Transfer Reset Password',
            meta: {
              auth: false,
              skipStructure: true,
              skipMenu: true,
              showSideBar: false,
              showHeader: true,
              footer: true,
              description: 'transfer_reset_description',
              identifierPath: 'transfer-reset-password',
            },
            component: require('../views/auth/TransferResetPassword').default,
          },
          {
            path: 'reset-password',
            name: 'Reset Password',
            meta: {
              auth: false,
              skipStructure: true,
              skipMenu: true,
              showSideBar: false,
              showHeader: true,
              footer: true,
              description: 'reset_pass_description',
              identifierPath: 'reset-password',
              T: 'reset_password',
            },
            component: require('../views/auth/ResetPassword').default,
          },
          {
            path: 'set-auth-key/:key',
            name: 'Set authentication key',
            meta: {
              skipStructure: true,
              skipMenu: true,
              showSideBar: false,
              showHeader: true,
              footer: true,
            },
            component: require('../views/auth/SetAuthKey').default,
          },
          {
            name: 'IB tracking link redirector',
            meta: {
              active: false,
              auth: false,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'ib/r',
            component: require('../views/partner/TrackingLinkRedirector').default,
          },
          {
            name: 'Return Confirmo',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/bitcoin/return',
            component: require('../views/finance/deposit-return/Bitcoin').default,
          },
          {
            name: 'Return RegularPay Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/regularpay/success',
            component: require('../views/finance/deposit-return/RegularPaySuccess').default,
          },
          {
            name: 'Return RegularPay Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/regularpay/failed',
            component: require('../views/finance/deposit-return/RegularPayFailed').default,
          },
          {
            name: 'Return EData Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/e-data/success',
            component: require('../views/finance/deposit-return/EDataSuccess').default,
          },
          {
            name: 'Return EData Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/e-data/failed',
            component: require('../views/finance/deposit-return/EDataFailed').default,
          },
          {
            name: 'Return Skrill Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/skrill/success',
            component: require('../views/finance/deposit-return/SkrillSuccess').default,
          },
          {
            name: 'Return Skrill Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/skrill/failed',
            component: require('../views/finance/deposit-return/SkrillFailed').default,
          },
          {
            name: 'Return Neteller Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/neteller/success',
            component: require('../views/finance/deposit-return/NetellerSuccess').default,
          },
          {
            name: 'Return Neteller Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/neteller/failed',
            component: require('../views/finance/deposit-return/NetellerFailed').default,
          },
          {
            name: 'Return PayRedeem Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/vload/success',
            component: require('../views/finance/deposit-return/VLoadSuccess').default,
          },
          {
            name: 'Return PayRedeem Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/vload/failed',
            component: require('../views/finance/deposit-return/VLoadFailed').default,
          },
          {
            name: 'Return KoalaPay Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/koalapay/success',
            component: require('../views/finance/deposit-return/KoalaPaySuccess').default,
          },
          {
            name: 'Return KoalaPay Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/koalapay/failed',
            component: require('../views/finance/deposit-return/KoalaPayFailed').default,
          },
          {
            name: 'Return Fasapay Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/fasapay/success',
            component: require('../views/finance/deposit-return/FasapaySuccess').default,
          },
          {
            name: 'Return Fasapay Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/fasapay/failed',
            component: require('../views/finance/deposit-return/FasapayFailed').default,
          },
          {
            name: 'Return Pago',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/pago/return',
            component: require('../views/finance/deposit-return/PagoCUP').default,
          },
          {
            name: 'Return Crypto Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/lydiax/success',
            component: require('../views/finance/deposit-return/LydiaxSuccess').default,
          },
          {
            name: 'Return Crypto Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/lydiax/failed',
            component: require('../views/finance/deposit-return/LydiaxFailed').default,
          },
          {
            name: 'Return SafeCharge Success',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/safecharge/success',
            component: require('../views/finance/deposit-return/SafeChargeSuccess').default,
          },
          {
            name: 'Return SafeCharge Failed',
            meta: {
              active: false,
              auth: true,
              skipStructure: true,
              skipMenu: true,
              showSideBar: true,
              showHeader: true,
              footer: true,
            },
            path: 'deposit/safecharge/failed',
            component: require('../views/finance/deposit-return/SafeChargeFailed').default,
          },
        ],
        beforeEnter: (to, from, next) => {
          const lang = to.params.lang
          if (!['en', 'es', 'fa'].includes(lang)) {
            return next(i18n.locale)
          }
          if (i18n.locale !== lang) {
            i18n.locale = lang
          }
          return next()
        },
      },
      {
        // redirect to default language
        path: '/',
        redirect: `/${i18n.locale}`,
      },
      { path: '*', name: '404', component: NotFound },
    ]
  },
}
